import type {TranscriptPrintChartPalette} from './TranscriptPrintChart';

export interface TranscriptPrintPalette extends TranscriptPrintChartPalette {
  text: string;
  surface: string;
  fontFamily: string;
  monospaceFontFamily: string;
}

/** Stylesheet for the standalone print document, with theme values passed in resolved. */
export const buildTranscriptPrintStyles = (
  palette: TranscriptPrintPalette
): string => `
@page { margin: 16mm; }
html, body { margin: 0; padding: 0; }
body {
  font-family: ${palette.fontFamily};
  color: ${palette.text};
  font-size: 11pt;
  line-height: 1.45;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
h1 { font-size: 18pt; margin: 0 0 4pt; }
.meta { list-style: none; margin: 0 0 12pt; padding: 0; color: ${palette.dimmed}; font-size: 9pt; }
.message { border-top: 1px solid ${palette.border}; padding: 8pt 0; }
.message-header { font-weight: 600; font-size: 10pt; color: ${palette.dimmed}; margin: 0 0 4pt; break-after: avoid; }
.user-text { white-space: pre-wrap; overflow-wrap: anywhere; margin: 0 0 6pt; }
.markdown { overflow-wrap: anywhere; }
.markdown p { margin: 0 0 6pt; }
.markdown ul, .markdown ol { margin: 0 0 6pt; padding-left: 18pt; }
.markdown pre { white-space: pre-wrap; background: ${palette.surface}; border-radius: 4pt; padding: 6pt; }
.markdown code { font-family: ${palette.monospaceFontFamily}; font-size: 0.9em; }
.tools { font-size: 9pt; color: ${palette.dimmed}; margin: 0 0 6pt; padding-left: 16pt; }
.chart { margin: 0 0 8pt; }
.chart-figure { break-inside: avoid; margin: 0 0 6pt; }
.chart-title { font-weight: 600; margin: 0 0 4pt; break-after: avoid; }
.chart svg { display: block; }
.chart .swatch { display: inline-block; flex-shrink: 0; }
.chart-legend { display: flex; flex-wrap: wrap; gap: 2pt 12pt; list-style: none; margin: 4pt 0 0; padding: 0; font-size: 9pt; }
.chart-legend li { display: flex; align-items: center; gap: 4pt; }
.pie-legend { list-style: none; margin: 6pt 0 0; padding: 0; width: 320px; font-size: 9pt; }
.pie-legend li { display: flex; justify-content: space-between; gap: 12pt; break-inside: avoid; }
.pie-legend .legend-name { display: flex; align-items: center; gap: 4pt; min-width: 0; overflow-wrap: anywhere; }
.chart table { border-collapse: collapse; }
.chart thead { display: table-header-group; }
.chart tr { break-inside: avoid; }
.chart th, .chart td { border: 1px solid ${palette.border}; padding: 3pt 6pt; text-align: left; vertical-align: top; }
.chart .num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.note { font-style: italic; font-size: 9pt; color: ${palette.dimmed}; margin: 4pt 0 0; }
`;
